import React from 'react';
import { Link } from 'react-router-dom';
import {
  DocumentTextIcon,
  ArrowPathIcon,
  CheckCircleIcon,
} from '../../icons';

const KPI_TONES = {
  primary: 'md-card-kpi-primary',
  dark: 'md-card-kpi-dark',
  warm: 'md-card-kpi-warm',
};

const SubtleStatTile = ({ label, value, hint, detail, tone = 'primary', icon: Icon, to }) => {
  const content = (
    <div className={`md-card h-full ${KPI_TONES[tone] || KPI_TONES.primary}`}>
      <div className="md-card-body p-4 h-full flex flex-col">
        <div className="flex items-start justify-between gap-3">
          <span className="text-[11px] font-semibold uppercase tracking-wider text-white/70">
            {label}
          </span>
          {Icon && (
            <div className="md-icon-well bg-white/15 text-white shadow-[inset_2px_2px_6px_rgba(0,0,0,0.2),inset_-2px_-2px_6px_rgba(255,255,255,0.12)]">
              <Icon className="h-6 w-6" />
            </div>
          )}
        </div>
        <div className="mt-3">
          <h5 className="text-3xl font-bold text-white mb-0 tracking-tight leading-none">{value}</h5>
          {hint && (
            <p className="text-sm text-white/80 mt-2 mb-0 font-medium">{hint}</p>
          )}
          {detail && (
            <p className="text-xs text-white/55 mt-1 mb-0 leading-snug">{detail}</p>
          )}
        </div>
      </div>
    </div>
  );

  if (to) {
    return (
      <Link to={to} className="block hover:opacity-95 transition-opacity h-full">
        {content}
      </Link>
    );
  }

  return content;
};

const RegistrarStatsGrid = ({ stats }) => {
  const processingHint =
    stats.processing === 0
      ? 'Queue clear'
      : stats.processing === 1
        ? '1 session in pipeline'
        : `${stats.processing} sessions in pipeline`;

  const reviewHint =
    stats.awaitingReview === 0
      ? 'Nothing waiting'
      : stats.awaitingReview === 1
        ? '1 draft ready'
        : `${stats.awaitingReview} drafts ready`;

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 h-full">
      <SubtleStatTile
        label="Total transcripts"
        value={stats.totalTranscripts}
        hint={`${stats.hoursRecorded || 0} hrs recorded`}
        detail={
          stats.sessionsToday > 0
            ? `${stats.sessionsToday} new session${stats.sessionsToday === 1 ? '' : 's'} today`
            : 'All proceedings in your court'
        }
        tone="primary"
        icon={DocumentTextIcon}
        to="/transcriptions"
      />
      <SubtleStatTile
        label="Processing"
        value={stats.processing}
        hint={processingHint}
        detail="Live and queued transcription jobs"
        tone="dark"
        icon={ArrowPathIcon}
        to="/sessions"
      />
      <SubtleStatTile
        label="Awaiting review"
        value={stats.awaitingReview}
        hint={reviewHint}
        detail="Completed drafts pending certification"
        tone="warm"
        icon={CheckCircleIcon}
        to="/transcriptions"
      />
    </div>
  );
};

export default RegistrarStatsGrid;
